import type { ReactNode } from 'react';
import { AccessCodeScreen } from '@/components/gate/AccessCodeScreen';
import { useSiteAccess } from '@/hooks/useSiteAccess';

/**
 * Puerta del sitio. Envuelve la aplicación entera, no sólo la home: mientras
 * el backend no valide el código, ninguna ruta se monta.
 *
 * Alcance honesto: el sitio es una SPA estática, así que quien sepa lo que
 * hace puede leer el bundle sin pasar por acá. Lo que la puerta garantiza es
 * que el código no viaja en ese bundle y que nadie la abre desde el navegador
 * — no que el contenido sea inaccesible.
 */
export function AccessGate({ children }: { children: ReactNode }) {
  const { status, error, submitting, submit } = useSiteAccess();

  // Revalidando un token guardado. Neutro a propósito: adelantar la home a
  // quien después va a quedar afuera sería mostrar lo que se está tapando.
  if (status === 'checking') {
    return <div className="min-h-screen bg-paper" aria-busy="true" />;
  }

  if (status === 'locked') {
    return <AccessCodeScreen error={error} submitting={submitting} onSubmit={submit} />;
  }


  return <>{children}</>;
}
